import React, {Component} from "react";
import {Tabs} from 'antd';
import getSize from "../../../../utils/getSize";
import XsjfxxcxTab from "./xsjfxxcxTab";
import XsjfxxcxhzTab from "./xsjfxxcxhzTab";
import css from './index.css';

const TabPane = Tabs.TabPane;

/**
 * 学生缴费信息查询
 * @author huanghaoyu
 * @date 2018-06-27 14:29:32
 * Version: 1.0
 */
export default class Xsjfxxcx extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            defaultActiveKey: undefined,
        }
    }


    render() {
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH}}>
                <Tabs defaultActiveKey={this.state.defaultActiveKey}>
                    <TabPane tab="学生缴费信息查询" key="1"><XsjfxxcxTab/></TabPane>
                    <TabPane tab="学生缴费信息汇总" key="2"><XsjfxxcxhzTab/></TabPane>
                </Tabs>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/xsjfxxcx/scjtXsjfxxcx/index.js